import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import guessPlayerImg from "../../../../../src/assets/games/guess-player.svg";
import Row from "react-bootstrap/Row";
import { AiOutlineArrowRight } from "react-icons/ai";
import { FaEquals } from "react-icons/fa";
import { ImgURL } from "../../../../globalData";
import PlayerSearch from "./PlayerSearch/PlayerSearch";
import { useTranslation } from "react-i18next";
import api from "../../../../apis";
import GameSuccessView from "../../GameSuccessView/GameSuccessView";
import { getUserPhoneNumbers } from "../../../../globalFn";
import { sendGameReport } from "../helper";

function GuessThePlayerModal({ show, onHide }) {
  const [showSuccessView, setShowSuccessView] = useState(false);
  const [guessPlayer, setGuessPlayer] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [teamsData, setTeamsData] = useState([]);

  const msisdn = getUserPhoneNumbers()[0]

  const { t } = useTranslation();

  useEffect(async () => {
    let teamDataFromApi = await api.guessPlayerGame.getTeamsLogos();
    const teamsArr = Object.entries(teamDataFromApi.data);
    setTeamsData(teamsArr);
  }, []);

  useEffect(() => {
    if (show) {
      sendGameReport("GuessThePlayer")
    }
  }, [show])

  const getPlayerInfo = (el) => {
    setGuessPlayer(el);
  };

  const handleSubmitAnswer = () => {
    let bodyData = {
      msisdn: msisdn,
      guess_id: teamsData[0][1],
      player: guessPlayer.name,
    };

    async function sendAnswer() {
      setIsLoading(true);
      setErrorMsg("");

      let res = await api.guessPlayerGame.postAnswer(bodyData);
      if (res?.status !== 200) {
        setErrorMsg(res.message);
        setIsLoading(false);
      } else {
        setGuessPlayer(null);
        setIsLoading(false);
        setShowSuccessView(true);

        const setTimeOutID = setTimeout(() => {
          onHide();
          clearTimeout(setTimeOutID);
        }, 2000);
      }
    }
    sendAnswer();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      contentClassName={"modal__content"}
      dialogClassName="modal__dialog"
    >
      <Modal.Header className="modal__header pt-3 p-3" closeButton />
      <Modal.Body className="show-grid">
        <Container>
          {showSuccessView ? (
            <GameSuccessView />
          ) : (
            <Row className=" justify-content-center">
              <Col
                xs={12}
                className="modal__bodyTitle text-center text-white m-2"
              >
                خمن اللاعب
              </Col>
              <Col
                xs={12}
                className="modal__bodyDescription text-center text-white p-2  m-3"
              >
                اعرف مين اللاعب اللي لعب للأندية الثلاثة التالية. (المسابقة 3 مرات أسبوعيا حتى نهاية كأس العالم)
              </Col>
              <Col
                xs={12}
                className="modal__bodyGame--question d-flex align-items-center justify-content-center text-center text-white"
              >
                {teamsData.slice(1).map((team) => {
                  return (
                    <React.Fragment key={team[1]?.name}>
                      <div className="team__countryLogo d-flex flex-column align-items-center">
                        <img src={ImgURL(team[1]?.logo)} alt="team one logo" />
                        <div className="team__name">{team[1]?.name}</div>
                      </div>
                      <AiOutlineArrowRight className="modal__gameIcon" />
                    </React.Fragment>
                  );
                })}

                <FaEquals className="modal__gameIcon" />
                <div className="team__countryLogo d-flex flex-column align-items-center ">
                  <img
                    className={`${!guessPlayer ? "bg-white" : ""}`}
                    src={
                      guessPlayer ? ImgURL(guessPlayer?.image) : guessPlayerImg
                    }
                    alt="player"
                  />
                  <div>
                    <PlayerSearch getPlayerInfo={getPlayerInfo} />
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </Modal.Body>
      {!showSuccessView && (
        <Modal.Footer className="modal__footer d-flex flex-column justify-content-center m-0">
          <Button
            className="text-capitalize"
            onClick={handleSubmitAnswer}
            disabled={isLoading || !guessPlayer}
          >
            {isLoading ? (
              <div
                className="spinner-border text-light fs-xs p-0"
                role="status"
                data-testid="guessThePlayerGame-submitBtn-loading"
              ></div>
            ) : (
              "تأكيد"
            )}
          </Button>
          <p className="error-msg">{errorMsg}</p>
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default GuessThePlayerModal;
